<template>
  <div>
    <b-card>
      <b-card-header>Shortcodes</b-card-header>
      <b-card-body class="pb-2">
        <code>[image_link url="TARGET_URL" thumbnail="IMAGE_URL"]</code><br />
        <br />
        <code>[sender_first_name]</code><br />
        <code>[sender_full_name]</code><br />
        <code>[recipient_first_name]</code><br />
        <code>[recipient_full_name]</code><br />
        <br />
        <code>[job_number]</code><br />
        <code>[job_address]</code><br />
        <code>[job_brand_name]</code><br />
        <code>[job_contact_first_name]</code><br />
        <code>[job_contact_full_name]</code><br />
        <br />
        <code>[billing_contact_first_name]</code><br />
        <code>[billing_contact_full_name]</code>
        <br />
        <br />
        NOTE: You can use <code>#YOUR_INPUT#</code> to define the initial input caret position.
      </b-card-body>
    </b-card>

    <table v-if="templates" class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Template Name</th>
          <th>Template Channel</th>
          <th>Template Text</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="templates.length">
        <tr v-for="(entry, index) in templates" :key="`contact-template-${target}-${index}`">
          <td>
            <input v-model="entry.id" type="hidden" />
            <input
              v-model.trim="entry.name"
              type="text"
              class="form-control form-control-sm"
              required="required"
            />
          </td>
          <td>
            <form-bootstrap-radio
              v-model="entry.channel"
              name="channel"
              :labelless="true"
              :options="['email', 'message']"
            />
          </td>
          <td>
            <textarea
              v-model.trim="entry.template"
              class="form-control form-control-sm"
              rows="10"
            />
            <text-count :text="entry.template" :max="160" class="text-muted text-right" />
          </td>
          <td>
            <font-awesome-icon
              :icon="['fal', 'times']"
              class="cursor"
              @click.stop="deleteTemplate(index)"
            />
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">
            <button type="button" class="btn btn-primary btn-sm" @click.stop="addTemplate">
              <font-awesome-icon :icon="['fal', 'plus-circle']" />
              Add Contact Customer Template
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script type="text/babel">
import TextCount from "../../../components/common/TextCount";

export default {
  components: { TextCount },

  props: {
    contactTemplateData: {
      type: Array,
      required: true,
      default: () => [],
    },

    brandId: {
      type: Number,
      required: true,
      default: 0,
    },

    target: {
      type: String,
      required: true,
      default: "customer",
    },
  },

  data() {
    return {
      channel: "email",
      templates: null,
    };
  },

  watch: {
    templates: {
      handler: function (value, oldValue) {
        if (oldValue) {
          this.emitChange();
        }
      },
      deep: true,
    },
  },

  created() {
    this.templates = this.contactTemplateData;
  },

  methods: {
    addTemplate() {
      this.templates.push({
        id: "",
        category: "contact",
        name: "",
        template: "",
        channel: "email",
        target: this.target,
        brand_id: this.brandId,
      });
    },

    deleteTemplate(index) {
      this.templates.splice(index, 1);
    },

    emitChange() {
      this.$emit("change", {
        target: this.target,
        channel: this.channel,
        templates: this.templates,
      });
    },
  },
};
</script>
